/* Chalgenius Affiliate Tracker v1 - storefront and accessible success pages */
(function (window, document) {
  'use strict';
  const script = document.currentScript;
  const vendorId = script && script.dataset.vendor;
  const endpoint = script && script.dataset.endpoint;
  const key = 'aff_click_id';
  const valid = value => typeof value === 'string' && /^[A-Za-z0-9_-]{6,100}$/.test(value);
  const getCookie = () => {
    const part = document.cookie.split('; ').find(v => v.startsWith(key + '='));
    if (!part) return null;
    try { return decodeURIComponent(part.slice(key.length + 1)); } catch (_) { return null; }
  };
  const incoming = new URL(window.location.href).searchParams.get(key);
  if (valid(incoming)) {
    document.cookie = key + '=' + encodeURIComponent(incoming) + '; Path=/; Max-Age=2592000; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  window.AffiliateTracker = {
    getClickId() { const value = getCookie(); return valid(value) ? value : null; },
    async trackOrder({ order_id } = {}) {
      const clickId = this.getClickId();
      if (!clickId) return { sent: false, reason: 'no_affiliate_click' };
      if (!vendorId || !endpoint || !/^https:\/\//.test(endpoint)) throw new Error('Missing vendor or HTTPS endpoint');
      if (typeof order_id !== 'string' || !/^[A-Za-z0-9_:#-]{1,120}$/.test(order_id)) throw new Error('Invalid order_id');
      const payload = { event: 'order_placed', vendor_id: vendorId, click_id: clickId, order_id };
      const response = await fetch(endpoint, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload), keepalive: true, credentials: 'omit' });
      if (!response.ok) throw new Error('Tracking endpoint returned HTTP ' + response.status);
      return { sent: true };
    }
  };
})(window, document);
